import React from "react";
import axios from 'axios';
import { redirectToLogin } from '../sessionExpiry';

export function useWaApi() {
  /**
   * We use useMemo to ensure the axios instance is stable across renders.
   * In the BFF pattern, we no longer depend on a 'token' variable.
   */
  return React.useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_WA_API_BASE_URL ,
      
      // CRITICAL: This allows the browser to automatically send the Session Cookie
      withCredentials: true, 
      
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', 
      }
    });

    /**
     * Optional: Global Response Interceptor
     * If any API call returns 401, the session is dead.
     * We trigger a redirect to the Gateway's login initiation path.
     */
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          console.warn("Session expired. Redirecting to Gateway login...");
          // Once per half minute at most: if the gateway still answers 401 right after a login, the page just shows its error.
          redirectToLogin();
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, []); // Empty dependency array because the cookie-based instance is static
}

